module.exports = `${require.publicPath}download-img02.7f9ad8aa.png`;